/**
 * AEB参数-批量读取结果展示表单
 */
import React, { useState, useEffect } from 'react';
import { Collapse, Form } from 'antd';
import ConfigForm from '@/components/configForm';
import { getLXConfigParams } from '@/constants/parameterConfiguration';

const { Panel } = Collapse;

interface AebParamsReadFormProps {
  data?: any; // 读取到的参数数据
}

const AebParamsReadForm: React.FC<AebParamsReadFormProps> = ({ data }) => {
  const [form] = Form.useForm();
  const [activeKeys, setActiveKeys] = useState<string[]>([]);

  // 当数据变化时设置表单值
  useEffect(() => {
    const resultDataStr = data?.resultData || ''
    const resultData = resultDataStr ? JSON.parse(resultDataStr) : {};
    // if (resultData) {
    form.setFieldsValue(resultData);
    // }
  }, [data, form]);

  // Collapse激活状态改变
  const handleCollapseChange = (keys: string | string[]) => {
    setActiveKeys(Array.isArray(keys) ? keys : [keys]);
  };

  return (
    <Form form={form} layout="vertical" disabled={true}>
      <ConfigForm
        formConfig={getLXConfigParams()}
        form={form}
        originData={data || {}} // 传入读取到的数据
        showCollapse={true}
        activeKeys={activeKeys}
        onCollapseChange={handleCollapseChange}
      />
    </Form>
  );
};

export default AebParamsReadForm;
